import { FC } from 'react'
import { Box, Button, Typography } from '@mui/material'
import theme from 'theme'

/* Utils */
import { CategoryActivityItem } from '../../../../../../models'

/* Components */
import { CategoryWrapper, ExploreCategoryWrapper } from './category.styles'
import { ChipTooltip } from '../../../../../components/tooltip/ChipTooltip'

interface Props {
  category: CategoryActivityItem
  handleCategoryClick: (category: string) => void
  handleCpiRedirect: (category: CategoryActivityItem) => void
  ishovered?: string
  minWidth?: string
}

const AvailableCategory: FC<Props> = ({ category, handleCategoryClick, handleCpiRedirect, ishovered, minWidth }) => (
  <CategoryWrapper
    className="available-category-wrapper"
    titlelength={category.name.length}
    ishovered={ishovered}
    sx={{ minWidth }}
  >
    <Box className="header" onClick={() => handleCategoryClick(category.name)}>
      <ChipTooltip
        PopperProps={{
          sx: {
            marginTop: `-${theme.spacing.sm}px !important`
          }
        }}
        title={
          <Box className="tooltip-wrapper-permissions one-line">
            <Typography className="tooltip-text">{category.name}</Typography>
          </Box>
        }
      >
        <Typography className="category-title category-margin">{category.name}</Typography>
      </ChipTooltip>
    </Box>

    <ExploreCategoryWrapper>
      <Box className="scale">
        <Typography className="scale-text">100%</Typography>
        <Typography className="scale-text">50%</Typography>
        <Typography className="scale-text">0%</Typography>
      </Box>
      <Box className="chart-button-wrapper">
        <Button onClick={() => handleCpiRedirect(category)}>
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M9 3L7.9425 4.0575L12.1275 8.25H3V9.75H12.1275L7.9425 13.9425L9 15L15 9L9 3Z" fill="#DEBDD9" />
          </svg>
          Explore CPIs
        </Button>
      </Box>
    </ExploreCategoryWrapper>
    <Typography className="available-status-sources-text">Data Sources: </Typography>
  </CategoryWrapper>
)

export default AvailableCategory
